var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex-column flex-align-center flex-justify-center flex-gap-2 h-100"},[_c('div',[_vm._v("Welcome, "+_vm._s(_vm.$store.state.user.firstName))]),_c('div',{staticClass:"font-size-2 bold"},[_vm._v("Dashboard Coming Soon")])])
}
var staticRenderFns = []

export { render, staticRenderFns }